<template>
	<router-view />
</template>
<script>
import "admin-lte/dist/css/adminlte.css"
import "admin-lte/plugins/fontawesome-free/css/all.min.css"
import "bootstrap/dist/css/bootstrap.css";


export default {
	name: 'app-view'
}
</script>

<style>
/* @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,600;1,700;1,800;1,900&display=swap'); */
@import url("https://cdn.jsdelivr.net/npm/bootstrap-icons@1.7.2/font/bootstrap-icons.css");
@import url("https://unpkg.com/boxicons@2.1.1/css/boxicons.min.css");
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');

* {
	font-family: 'Inter', sans-serif;
	/* margin: 0 auto; */
}

:root {
	--color-light: rgba(0, 0, 0, 0.5);
	--color-text: rgba(0, 0, 0, 0.6);
	--color-sub-judul: rgba(0, 0, 0, 0.8);
	--color-judul: #000;
	--color-red: #e74c3c;
	--color-green: #66c897;
	--color-white: #fff;
	--color-blue: #2980B9;
	--red: #e50019;
	--bg-grey: linear-gradient(56deg, rgba(226, 226, 226, 1) 0%, rgba(246, 246, 246, 1) 100%);
	--bg-black: linear-gradient(-90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%);
	--bg-light-red: linear-gradient(-56deg, rgba(245, 236, 236, 1) 0%, rgba(255, 255, 255, 1) 100%);
	--darkGrey: #1b1b1b;
	--grey: #7a7a7a;
	--green: #34A74F;
	--yellow: #F1A900;
	--bg-body: #F4F6F9;
	--light-grey: #CBCBCB;
	--transition: 0.4s;
}

/* ======= Badge ======= */
.badge-success {
	background: rgba(0, 229, 53, 0.1) !important;
	color: var(--green) !important;
}

.badge-warning {
	background: rgba(241, 169, 0, 0.2) !important;
	color: var(--yellow) !important;
}

.badge-danger {
	background: rgba(229, 0, 25, 0.1) !important;
	color: var(--red) !important;
}

.badge-info {
	background: rgba(0, 156, 229, 0.1) !important;
	color: rgba(0, 156, 229, 1) !important;
	font-weight: 500 !important;
	padding: 10px !important;
}

.badge-light {
	background: rgba(110, 110, 110, 0.1) !important;
	color: rgb(50, 50, 50) !important;
	font-weight: 500 !important;
	padding: 10px !important;
}

.content-wrapper {
	background: var(--bg-body);
}

a.router-link-exact-active {
	color: var(--red);
}

.bg-red {
	background: var(--red) !important;
}

.btn_red {
	background: var(--red) !important;
	font-size: 12pt !important;
	text-transform: capitalize !important;
	padding: 15px !important;
	color: white !important;
	border-radius: 5px !important;
	box-shadow: 0 10px 30px rgba(229, 0, 25, 0.2);
	font-weight: 600 !important;
}

.btn_red:hover {
	background: #cf0119 !important;
}

.btn__primary {
	background: #ffe0e4 !important;
	color: var(--red) !important;
	border-radius: 5px !important;
	font-weight: 600 !important;
}

.btn__primary:hover {
	background: #cf0119 !important;
	color: white !important;
}

.btn_grey {
	background: var(--grey) !important;
	font-size: 12pt !important;
	text-transform: capitalize !important;
	padding: 15px !important;
	color: white !important;
	border-radius: 5px !important;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
	font-weight: 600 !important;
}

.btn_light {
	background: var(--light-grey) !important;
	color: var(--darkGrey) !important;
	border-radius: 5px !important;
	font-weight: 600 !important;
	padding: 15px !important;
}

.btn_outline_red {
	background: white !important;
	padding: 15px !important;
	color: var(--red) !important;
	border: 1px solid var(--red) !important;
	border-radius: 5px !important;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
	font-weight: 600 !important;
}

.btn_outline_red:hover {
	background: var(--red) !important;
	color: white !important;
	border: 1px solid var(--red) !important;
}

.alert-danger {
	background: rgba(229, 0, 25, 0.2) !important;
	color: var(--red) !important;
}

input.form-control,
input.form-select {
	padding: 26px;
}

/* select.form-control{
	padding: 26px;
} */
input.form-control:focus {
	border-color: var(--red);
	box-shadow: none;
}

select.form-select:focus {
	border-color: var(--red);
	box-shadow: none;
}

textarea.form-control:focus {
	border-color: var(--red);
	box-shadow: none;
}

select.form-control:focus {
	border-color: var(--red);
	box-shadow: none;
}

/* #app {
  background: linear-gradient(to left, #fff2f2 100%,  #ffd3d3 0%);
} */
</style>
